/**
 * Getters for clients
 */
export const getters = {
  getClients(state) {
    return state.clients;
  },
  getActive(state) {
    return state.active;
  },
  getLoading(state) {
    return state.loading;
  },
  getDataLoaded(state) {
    return state.dataLoaded;
  },
  getMode(state) {
    return state.mode;
  },
  getEditClientId(state) {
    return state.editClientId;
  }
};
